import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { CreateListingForm } from '~/features/listings/components/create-listing-form'
import {
  type PlaceSaveOutcome,
  PlaceWebsiteFlow,
} from '~/features/listings/website-start/place-website-flow'
import * as m from '~/paraglide/messages'
import { ManualStartIcon } from '~/shared/ui/manual-start'

export const Route = createFileRoute('/dashboard/listings/create')({
  validateSearch: (search) => ({
    manual: search.manual === true || search.manual === 'true' ? true : undefined,
  }),
  component: CreateListingRoute,
})

function CreateListingRoute() {
  const { manual } = Route.useSearch()
  const navigate = useNavigate()

  const openSaved = (listingId: string, outcome: PlaceSaveOutcome) =>
    outcome === 'publishFailed'
      ? navigate({ to: '/dashboard/listings/$listingId/edit', params: { listingId } })
      : navigate({ to: '/dashboard/listings/$listingId', params: { listingId } })

  if (manual) {
    return (
      <CreateListingForm
        onCreated={(listingId, outcome) =>
          outcome === 'publishFailed'
            ? openSaved(listingId, outcome)
            : navigate({ to: '/dashboard/listings' })
        }
        onCancel={() => navigate({ to: '/dashboard/listings' })}
      />
    )
  }
  return (
    <PlaceWebsiteFlow
      onSaved={openSaved}
      manualLink={
        <Link to="/dashboard/listings/create" search={{ manual: true }}>
          <ManualStartIcon />
          {m.placeWebManual()}
        </Link>
      }
    />
  )
}
